import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../../utils/firebase';
import { collection, addDoc } from 'firebase/firestore';
import {useAuth} from "../../context/AuthContext";
import {useLang} from "../../context/LanguageContext";
import Footer from "../../components/Footer";

const LeaveReviewPage = () => {
  const navigate = useNavigate();
  const {hasPaid} = useAuth();
  const { t, language } = useLang()


  useEffect(() => {
    if (!hasPaid) {
      navigate('/account');
    }
  }, [hasPaid, navigate]);

  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [stars, setStars] = useState(0);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);


  const handleSendReview = async () => {
    setError(null);
    setSuccess(false);

    if (!name.trim()) {
      setError('Please enter a name.');
      return;
    }
    if (!message.trim()) {
      setError('Please enter a message.');
      return;
    }
    if (stars <= 0) {
      setError('Please select a star rating.');
      return;
    }

    const now = new Date();
    const day = now.getDate();
    const month = now.getMonth();
    const year = now.getFullYear();
    const dataMesaj = t(`months.${month}`) + ` ${day}, ${year}`;

    const docData = {
      dataMesaj,
      mesajReview: message,
      nume: name,
      status: false,
      numarStele: stars.toString(),
      timeStamp: now.getTime(),
      language: language
    };

    try {
      await addDoc(collection(db, 'reviews'), docData);
      setSuccess(true);
    } catch (err) {
      console.error('Error adding review:', err);
      setError('Could not save review. Please try again.');
    }
  };

  const renderStars = () => {
    const starsArr = [];
    for (let i = 1; i <= 5; i++) {
      starsArr.push(
        <button
          key={i}
          onClick={() => setStars(i)}
          type="button"
          className="text-2xl mr-1"
        >
          {i <= stars ? '★' : '☆'}
        </button>
      );
    }
    return starsArr;
  };

  return (
    <div className="relative bg-gray-100 min-h-screen p-5">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-gray-300 rounded"
      >
        {t('btn.back')}
      </button>

      <h1 className="text-xl font-bold text-center mt-16 mb-4">Leave a review</h1>

      <div className="flex flex-col space-y-3 max-w-[400px] mx-auto">
        {error && <p className="text-red-500 mb-2">{error}</p>}
        {success && <p className="text-green-600 mb-2">Thank you for your review!</p>}
        <input
          type="text"
          placeholder="Name"
          className="border p-2 rounded"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <textarea
          placeholder="Message"
          className="border p-2 rounded h-24"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <div className="flex items-center">
          {renderStars()}
        </div>
        <button
          onClick={handleSendReview}
          className="bg-green-500 text-white font-bold py-2 px-4 rounded"
        >
          SEND
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default LeaveReviewPage;
